import "./PetHealth.module.css";
import Header from "@/reusable_sections/Header";
import Intro from "./sections/Intro";
import Topics from "./sections/Topics";
import Articles from "./sections/Articles";
import VetContact from "./sections/VetContact";
import Footer from "@/reusable_sections/Footer";
export default function PetHealthPage() {
  return <div>
      <Header />
      <Intro />
      <Topics />
      <Articles />
      <VetContact />
      <Footer />
    </div>;
}